var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSeedtraceLogoIconBlackColor = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#0F1412;}\n\t.st4{fill:#ECB301;}\n\t.st5{display:inline;opacity:0.2;fill:#FF00FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300,10C140.1,10,10,140.1,10,300s130.1,290,290,290c159.9,0,290-130.1,290-290S459.9,10,300,10z M543.4,300 c0,134.2-109.2,243.4-243.4,243.4C165.8,543.4,56.6,434.2,56.6,300S165.8,56.6,300,56.6C434.2,56.6,543.4,165.8,543.4,300z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M425.3,321.9c-12.5-14.3-27.6-25.3-44.8-32.7c-16.9-7.2-38.8-14.5-65.1-21.5c-19.5-5.6-34.5-10.4-44.5-14.1 c-9.6-3.6-17.9-8.5-24.6-14.8c-6.4-6-9.5-13.2-9.5-22c0-11.3,4.7-20.1,14.4-27c9.9-7,24.6-10.6,43.5-10.6c19.3,0,34.8,4.6,46,13.7 c11.2,9.2,17.3,21.1,18.6,36.6c0.1,1.6,1.5,2.9,3.1,2.9h74.9c0.9,0,1.7-0.4,2.3-1c0.6-0.6,0.9-1.5,0.9-2.3 c-1.8-36.7-15.8-66.1-41.5-87.4c-25.7-21.2-59.8-31.9-101.6-31.9c-27.9,0-53,4.7-74.5,14.1c-21.7,9.4-38.6,22.5-50.3,38.8 C161,179.3,155,197.7,155,217.5c0,24.3,6.6,44.2,19.5,59.2c12.8,14.8,28.1,25.9,45.5,33.1c17.1,7,39.6,14.4,66.7,21.8 c27.7,7.8,48.2,15,60.9,21.5c11.9,6,17.7,15,17.7,27.4c0,11.7-5.3,21.1-16.1,28.6c-11,7.7-26.9,11.6-47.2,11.6 c-9.5,0-18.3-1.2-26.2-3.6c-0.1,0-0.3-0.1-0.4-0.1c-12.4-3.3-18.7-1.8-23.2,5.8c-18.5,31.4-39.2,36.9-41.3,37.3 c-1.3,0.1-2.4,1-2.7,2.3c-0.4,1.4,0.2,2.8,1.4,3.5c5.1,3,10.4,5.8,15.9,8.3c22.9,10.4,49.1,15.7,77.9,15.7 c28.3,0,53.4-4.7,74.5-14.1c21.2-9.4,37.9-22.6,49.6-39.2c11.7-16.7,17.7-35.9,17.7-57.1C444.7,355.9,438.1,336.5,425.3,321.9 C425.3,321.9,425.3,321.9,425.3,321.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 193.3,
    cy: 409.9,
    r: 38.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSeedtraceLogoIconBlackColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/seedtrace_logo_icon_black_color.48dc9f78e377514e5683e58d0a1e6f46.svg";